import React, { useState, useRef, useEffect } from 'react';

import { iframePostMessage } from 'utils/constants';
import { Config } from 'utils/config/config';

import './styles.scss';

const DEFAULT_IFRAME_DOCUMENT_HEIGHT = 322;

const LessonIframe = (props: any) => {
  const {
    location: { pathname, state, search },
  } = props;
  const [loadedIframe, setLoadedIframe] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [iframe, setIframe] = useState<Window | null | undefined>(null);
  const [iframeHeight, setIframeHeight] = useState<number>(
    DEFAULT_IFRAME_DOCUMENT_HEIGHT,
  );

  const onIframeLoaded = () => {
    let iframeWindow: Window | null | undefined;
    if (iframe === null) {
      iframeWindow = iframeRef.current?.contentWindow;
      setIframe(iframeWindow);
      setLoadedIframe(true);
    }
  };

  const handleIframeMessage = (event: any) => {
    const { payload } = event.data;
    if (payload && payload.action === iframePostMessage.UPDATE_CONTENT_HEIGHT) {
      setIframeHeight(payload.contentHeight);
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleIframeMessage);

    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, []);

  const iframeUrl = `${Config.HYLIA_WEB_URL}${pathname}${search}`;
  return (
    <div
      data-testid={!loadedIframe ? 'lesson-iframe' : 'lesson-loaded-iframe'}
      styleName="document fullscreen-iframe"
    >
      {!Config.HYLIA_WEB_URL ? (
        <div>Please define HYLIA_WEB_URL</div>
      ) : (
        <iframe
          title={`${state?.program || ''}-lesson-iframe`}
          scrolling="no"
          ref={iframeRef}
          src={iframeUrl}
          styleName="iframe-wrapper fullscreen-iframe"
          onLoad={onIframeLoaded}
          height={iframeHeight}
        />
      )}
    </div>
  );
};

export default LessonIframe;
